<template>
  <BaseCard ref="base-card" collapsable :footer-visible="false">
    <template #title>
      <b-row align-v="center" align-h="between">
        <b-col class="font-weight-bold d-flex align-items-center" cols="auto">
          <span class="text-uppercase">condiciones</span>
        </b-col>
      </b-row>
    </template>
    <b-row class="p-2">
      <b-col cols="6" class="mb-50">
        <div class="font-weight-bold">Hitos de facturación:</div>
        <div class="text-light">
          {{ billingMilestone }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-50">
        <div class="font-weight-bold">Avales y garantías:</div>
        <div class="text-light">
          {{ endorsementsAndGuarantees }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-50">
        <div class="font-weight-bold">Formas de pago:</div>
        <div class="text-light">
          {{ typePayment }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-50">
        <div class="font-weight-bold">Tipo de impuesto:</div>
        <div class="text-light">
          {{ tax }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-50">
        <div class="font-weight-bold">Condiciones de retenciones:</div>
        <div class="text-light">
          {{ withholdingConditions }}
        </div>
      </b-col>
    </b-row>
  </BaseCard>
</template>

<script>
import { mapGetters } from "vuex";
import BaseCard from "@/components/ui/card/BaseCard.vue";

export default {
  name: "offerConditionsCard",
  components: { BaseCard },
  computed: {
    ...mapGetters("offer", {
      offer: "getOffer",
    }),
    tax() {
      return this.offer?.tax?.name || "Sin IVA";
    },
    typePayment() {
      return this.offer?.type_payment?.name || "Sin formas de pago";
    },
    withholdingConditions() {
      return (
        this.offer?.withholding_conditions || "Sin condiciones de retención"
      );
    },
    endorsementsAndGuarantees() {
      return (
        this.offer?.endorsements_and_guarantees || "Sin avales ni garantías"
      );
    },
    billingMilestone() {
      return this.offer?.billing_milestone || "Sin hitos de facturación";
    },
  },
  methods: {
    setCollapse(collapse) {
      this.$refs["base-card"].setCollapse(collapse);
    },
  },
};
</script>
